import { css, styled } from "@/root/stitches.config";

import { generateMetadata } from "@/utils/helper";
import withNavbarMobile from "@/hooks/hoc/withNavbarMobile";

import Image from "./partials/Image";
import HeaderSection from "./partials/HeaderSection";
import PriceSection from "./partials/PriceSection";
import DescriptionSection from "./partials/DescriptionSection";

const Container = styled("section", {
    display: "block",
    height: "max-content",
    width: "100%",
    padding: "2rem 5%",
    backgroundColor: "$white",
    "@desktop": { paddingTop: "9.5rem" },
    "@laptop": { paddingTop: "9rem" },
    "@tablet": { paddingTop: "8.5rem" },
    "@mobile": { paddingTop: "0rem" },
});

const Divider = styled("span", {
    display: "block",
    width: "100%",
    height: "0.2vw",
    backgroundColor: "$dark",
});

function DetailPage({ data, links: { orderUrl }, meta }) {
    const isActivity = data.type.toLowerCase() === "activity";

    return (
        <>
            {generateMetadata(meta.head)}
            <Container>
                <div
                    className={css({
                        display: "grid",
                        gridTemplateColumns: "450px auto",
                        gap: "3rem",
                        "@mobile": {
                            gridTemplateColumns: "repeat(1, 1fr)",
                            gap: "0.5rem",
                        },
                        "& > :first-child": {
                            overflow: "hidden",
                        }
                    }).toString()}
                >
                    <Image type={data.type} src={data.image_url} />
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "1.25rem",
                        }}
                    >
                        <HeaderSection
                            name={data.name}
                            type={data.type}
                            isActivity={isActivity}
                            closedDate={isActivity ? data.date : data.registration_closed_at}
                        />
                        <Divider />
                        <PriceSection
                            price={isActivity ? data.sale.price : data.price}
                            priceTag={
                                isActivity ? data.sale.name : data.price_tag
                            }
                            isActivity={isActivity}
                            isClosed={data.is_closed}
                            isFull={data.is_quota_full}
                            isTicketsAvailable={
                                isActivity && data.sale.is_tickets_available
                            }
                            isGoingOn={
                                isActivity && data.is_going_on
                            }
                            isComingUp={
                                isActivity ? data.is_coming_up : data.is_opened
                            }
                            guideBook={isActivity ? null : data.guide_book_url}
                            orderUrl={orderUrl}
                            altLink={isActivity ? null : data.is_alt_link}
                        />
                        <Divider />
                        <DescriptionSection description={data.description} />
                    </div>
                </div>
            </Container>
        </>
    );
}

export default withNavbarMobile(DetailPage);
